// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"630":"code_activation-CodeActivationModal","777":"code_activation-PhoneVerification"}[chunkId] + "." + {"630":"fd561480a4c85cfaa69e","777":"9f30182c3e248e6d99df"}[chunkId] + ".js";
};